import React from 'react';
import FontAwesome from 'react-fontawesome';

import { formatCrewName } from '../../utils';

const CrewName = ({ crew }) => (
  <span>
    <FontAwesome name="square" style={{ color: crew && crew.equipment && crew.equipment.color ? crew.equipment.color : '#fafafa' }} />
    {` ${formatCrewName(crew)}`}
  </span>
);

export default CrewName;
